import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { Box, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AppLayout from "../../Components/AppLayout";
import AuthLayout from "../../Components/AuthLayout";
import KenLoader from "../../GlobalComponents/KenLoader";
import {
  getAxiosInstance,
  getPlayerRegestrationWindow,
} from "../../Utils/apiService";
import { PublicRoute } from "../../Utils/helperFunctions";
import routes from "../../Utils/routes";
// import ContactSuccess from "../Auth/ContactSuccess";

// auth
const RegistrationNumBer = React.lazy(
  () => import("../Auth/RegistrationNumber/index"),
);
const Login = React.lazy(() => import("../Auth/Login/index"));
const OtpVerify = React.lazy(() => import("../Auth/VerifyOtp"));
const ContactUs = React.lazy(() => import("../Auth/ContactUs"));
// home
const Home = React.lazy(() => import("../Home/index"));
const Launcher = React.lazy(() => import("../Launcher"));
const ThankYou = React.lazy(() => import("../ThankYou"));
const Closed = React.lazy(() => import("../Closed"));
const ContactSuccess = React.lazy(() => import("../Auth/ContactSuccess"));

// register
const Register = React.lazy(() => import("../Register"));

//Not Found

// const helpLinkHiddenRoutes = [
//   routes.contactUs,
//   routes.thankYou,
//   routes.closed,
//   routes.launcher,
//   routes.registrationNumber,
//   routes.login,
// ];

const MainLayout: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [isWindowIsClosed, setIsWindowIsClosed] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    getAxiosInstance();
  }, []);

  const fetchWindow = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getPlayerRegestrationWindow();
      const allWindows = response.data?.data ?? [];
      const currentDateUTC = Date.now();

      const activeWindows = allWindows.filter((windowItem: any) => {
        const startDateUTC = Date.parse(windowItem?.Start_Date_Time__c);
        const endDateUTC = Date.parse(windowItem?.End_Date_Time__c);
        return (
          Number.isFinite(startDateUTC) &&
          Number.isFinite(endDateUTC) &&
          currentDateUTC >= startDateUTC &&
          currentDateUTC <= endDateUTC
        );
      });

      const windowDetails =
        [...activeWindows].sort(
          (a: any, b: any) =>
            Date.parse(b?.Start_Date_Time__c) -
            Date.parse(a?.Start_Date_Time__c),
        )[0] ??
        [...allWindows].sort(
          (a: any, b: any) =>
            Date.parse(b?.Start_Date_Time__c) -
            Date.parse(a?.Start_Date_Time__c),
        )[0];

      if (windowDetails) {
        const endDateUTC = Date.parse(windowDetails.End_Date_Time__c);
        const startDateUTC = Date.parse(windowDetails.Start_Date_Time__c);
        const isClosed = currentDateUTC > endDateUTC;
        const startYear = Number.isFinite(startDateUTC)
          ? new Date(startDateUTC).getUTCFullYear()
          : null;
        const endYear = Number.isFinite(endDateUTC)
          ? new Date(endDateUTC).getUTCFullYear()
          : null;
        const seasonLabel =
          startYear && endYear
            ? startYear === endYear
              ? `${startYear}`
              : `${startYear}-${String(endYear).slice(-2)}`
            : "unknown";
        console.info(
          "[RegistrationWindow] Now:",
          new Date(currentDateUTC).toISOString(),
        );
        console.info(
          "[RegistrationWindow] Start:",
          windowDetails.Start_Date_Time__c,
        );
        console.info(
          "[RegistrationWindow] End:",
          windowDetails.End_Date_Time__c,
        );
        console.info("[RegistrationWindow] Season:", seasonLabel);
        console.info(
          "[RegistrationWindow] Status:",
          isClosed ? "closed" : "open",
        );
        if (windowDetails?.Id) {
          localStorage.setItem("playerRegWindowId", windowDetails.Id);
        }
        setIsWindowIsClosed(isClosed);
      } else {
        localStorage.removeItem("playerRegWindowId");
        console.info(
          "[RegistrationWindow] No window details found. Status: open",
        );
        setIsWindowIsClosed(false);
      }
    } catch (error) {
      console.error("Error fetching registration window:", error);
      setIsWindowIsClosed(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchWindow();
  }, [fetchWindow]);

  const renderAuthLayout = (page: React.ReactNode) => (
    <AuthLayout>{page}</AuthLayout>
  );

  const renderClosedGuardedAuthLayout = (page: React.ReactNode) =>
    isWindowIsClosed ? (
      <Navigate to={routes.closed} replace />
    ) : (
      renderAuthLayout(page)
    );

  return loading || isWindowIsClosed === null ? (
    <KenLoader hideIndicator />
  ) : (
    <>
      <Routes>
        {/* Initial Route */}
        {!loading && isWindowIsClosed !== null && (
          <Route
            path="/"
            element={
              <Navigate
                to={isWindowIsClosed ? routes.closed : routes.launcher}
                replace
              />
            }
          />
        )}
        <Route
          path={routes.registrationNumber}
          index
          element={renderClosedGuardedAuthLayout(<RegistrationNumBer />)}
        />
        <Route
          path={routes.login}
          index
          element={renderClosedGuardedAuthLayout(<Login />)}
        />
        <Route
          path={routes.contactUs}
          index
          element={renderAuthLayout(<ContactUs />)}
        />
        <Route
          path={routes.contactSuccess}
          element={renderAuthLayout(<ContactSuccess />)}
        />
        <Route
          path={routes.otpverification}
          element={renderClosedGuardedAuthLayout(<OtpVerify />)}
        />
        <Route
          path={routes.register}
          index
          element={renderClosedGuardedAuthLayout(
            <PublicRoute>
              <Register />
            </PublicRoute>,
          )}
        />

        <Route
          path={routes.launcher}
          element={renderClosedGuardedAuthLayout(<Launcher />)}
        />

        <Route
          path={routes.thankYou}
          element={renderAuthLayout(<ThankYou />)}
        />
        <Route path={routes.closed} element={renderAuthLayout(<Closed />)} />
        <Route
          path={routes.home}
          element={
            <AppLayout>
              <Home />
            </AppLayout>
          }
        />

        <Route
          path="*"
          element={
            <AppLayout>
              <Closed />
            </AppLayout>
          }
        />
      </Routes>
      {/* {!helpLinkHiddenRoutes.includes(pathname) && (
        <Box
          onClick={() => navigate(routes.contactUs)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              navigate(routes.contactUs);
            }
          }}
          role="button"
          tabIndex={0}
          aria-label="Need help? Contact us"
          sx={{
            position: "fixed",
            bottom: { xs: 84, md: 28 },
            right: { xs: 16, md: 32 },
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "#FFFFFF",
            cursor: "pointer",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            fontSize: { xs: "10px", md: "12px" },
            fontWeight: 600,
            textShadow: "0 6px 18px rgba(0,0,0,0.45)",
            userSelect: "none",
            outline: "none",
            "&:focus-visible": {
              boxShadow: "0 0 0 3px rgba(255, 255, 255, 0.45)",
              borderRadius: "999px",
              padding: "4px 8px",
              margin: "-4px -8px",
            },
          }}
        >
          <HelpOutlineRoundedIcon sx={{ fontSize: 18 }} />
          <Typography
            component="span"
            sx={{ fontSize: "inherit", opacity: 0.72 }}
          >
            Need Help?
          </Typography>
          <Typography
            component="span"
            sx={{
              fontSize: "inherit",
              textDecoration: "underline",
              textUnderlineOffset: "4px",
            }}
          >
            Contact Us
          </Typography>
        </Box>
      )} */}
    </>
  );
};

export default MainLayout;
